// packages/api/src/hooks/usePricingPermissions.ts
//
// Hook conveniente para split de permissions `pricing:manage/approve/publish`.
// O provider recebe `hasPermission` do app shell; este pacote não importa
// @alamo/auth para manter o grafo @alamo/auth -> @alamo/api acíclico.

import { createContext, createElement, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

import { buildPricingPermissions, type PricingPermissions } from './admin/usePilar2Workflow';

export type PricingPermissionReader = (resource: string, action: string) => boolean;

const PricingPermissionContext = createContext<PricingPermissionReader | null>(null);

export interface PricingPermissionsProviderProps {
  hasPermission: PricingPermissionReader;
  children: ReactNode;
}

export function PricingPermissionsProvider({
  hasPermission,
  children,
}: PricingPermissionsProviderProps) {
  return createElement(PricingPermissionContext.Provider, { value: hasPermission }, children);
}

export function usePricingPermissions(): PricingPermissions {
  const hasPermission = useContext(PricingPermissionContext);
  return useMemo(() => buildPricingPermissions(hasPermission ?? (() => false)), [hasPermission]);
}

export type { PricingPermissions };
